// extracted by mini-css-extract-plugin
module.exports = {"root":"primary_root__gLBcw"};